import { useFormik } from "formik";
import { useState } from "react";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useUpdateCertificatePriceMutation } from "../../../store/queries/CertificateUpdate";

const useCertificateUpdate = () => {
  const [updateCertificatePrice, { isLoading: loading }] =
    useUpdateCertificatePriceMutation();

  const typeOptions = [
    { label: "Single", value: "1" },
    { label: "Bulk", value: "2" },
  ];

  const validationSchema = Yup.object().shape({
    gli_number: Yup.string().required("GLI Number is required"),
    type: Yup.object().required("Type is required"),
    old_price: Yup.string().required("Old Price or Code is required"),
    new_price: Yup.string().required("New Price or Code is required"),
    from: Yup.string().required("Certificate Number From is required"),
    to: Yup.string().when("type", {
      is: (type) => type?.value === "2",
      then: () => Yup.string().required("Certificate Number To is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
  });

  const formik = useFormik({
    initialValues: {
      gli_number: "",
      type: typeOptions[0],
      from: "",
      to: "",
      old_price: "",
      new_price: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      const payload = {
        gli_number: values?.gli_number,
        type: values.type?.value,
        old_price: values?.old_price,
        new_price: values?.new_price,
        certificate_number:
          values?.type?.value === "2"
            ? { from: values?.from, to: values?.to }
            : values?.from,
      };
      try {
        const response = await updateCertificatePrice(payload).unwrap();
        if (response?.status_code === 200) {
          toast.success(response?.message || "Updated Successfully");
          formik.resetForm();
        } else {
          toast.error("Something went wrong");
        }
      } catch (error) {
        toast.error(error?.data?.message);
      }
    },
  });

  return {
    formik,
    typeOptions,
    loading,
  };
};

export default useCertificateUpdate;
